export default __webpack_public_path__ + "static/media/criteria-2.35e4134f.jpg";